import { EMPTY_STRING } from '../../../constants/common'
import { NUMBER_SIZE } from '../../../constants/size'
import i18n from '../../../i18n'
import { FileIconPreview } from '../../FileIcon'
import { TableDateCell, TableTextCell, TableTitleCell } from '../../Table'
import {
  FILE_ATTACHED_ITEMS_MODAL_TABLE_CELL_NAME,
  FILE_USER_ACCESS_PRIVATE,
} from '../File.constants'
import { getFileValueSize } from '../File.utils'

import * as styles from './FileAttachedItemsModalTableRow.module.css'

function getUserAccessLabel(value) {
  return i18n.t(
    value === FILE_USER_ACCESS_PRIVATE
      ? 'Modal.AttachedFilesPrivateTypeKey'
      : 'Modal.AttachedFilesPublicTypeKey'
  )
}

export function renderCell({ item, name, ...restProps }) {
  const { [name]: value } = item

  function Icon() {
    return (
      <FileIconPreview
        className={styles.fileIcon}
        file={item}
        size={NUMBER_SIZE.size24}
      />
    )
  }

  switch (name) {
    case FILE_ATTACHED_ITEMS_MODAL_TABLE_CELL_NAME.filename:
      return (
        <TableTitleCell
          {...restProps}
          Icon={Icon}
          tagsProps={{
            directoryId: item.directory_id,
          }}
          value={
            item.is_persistent ? i18n.t(value || item.name) : value || item.name
          }
        />
      )
    case FILE_ATTACHED_ITEMS_MODAL_TABLE_CELL_NAME.created:
      return <TableDateCell {...restProps} value={value} />
    case FILE_ATTACHED_ITEMS_MODAL_TABLE_CELL_NAME.size:
      return (
        <TableTextCell
          {...restProps}
          value={value ? getFileValueSize({ value }) : EMPTY_STRING}
        />
      )
    case FILE_ATTACHED_ITEMS_MODAL_TABLE_CELL_NAME.usersAccess:
      return (
        <TableTextCell
          {...restProps}
          value={value ? getUserAccessLabel(value) : EMPTY_STRING}
        />
      )
  }
}
